export function isElementInViewport(el?: any | null): boolean {
  if (el === undefined || el === null) {
    return false
  }
  
  var top = el.offsetTop
  var left = el.offsetLeft

  while(el!.offsetParent) {
    el = el!.offsetParent
    top += el.offsetTop
    left += el.offsetLeft
  }

  const root = document.getElementById("root")
  
  return (
    top < (root.offsetHeight + root.clientHeight) &&
    left < (root.offsetWidth + root.clientWidth)
  )
}